module.exports = __webpack_public_path__ + "static/media/globerack4x3s.9d2bd54d.jpg";